import React from 'react';

function CurrentAdminField({ data }) {
  const admin = data?.currentAdminInfo;
  const office = data?.customerInfo?.office;
  const responsible = office
    ? [admin?.businessName, office?.businessName, office?.office]
        .filter((value) => typeof value === 'string' && value.trim())
        .join(' - ')
    : [admin?.name, admin?.businessName]
        .filter((value) => typeof value === 'string' && value.trim())
        .join(' - ');

  return <>{responsible || '-'}</>;
}

export default CurrentAdminField;
